import { ChangeDetectionStrategy, Component, signal } from '@angular/core';

import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';
import type { ProductSeverity } from '../../../services/property-status/property-status.service.models';
import { ProductStatusBadgeComponent } from '../product-status-badge.component';

type IProductStatusCellRendererParams = ICellRendererParams<unknown, ProductSeverity, unknown> & {
  iconOnly?: boolean;
  message?: string;
};

@Component({
  selector: 'bxi-product-status-renderer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ProductStatusBadgeComponent],
  template: ` <bxi-product-status-badge [severity]="severity()" [iconOnly]="iconOnly()" [message]="message()"></bxi-product-status-badge> `,
})
export class ProductStatusRendererComponent implements ICellRendererAngularComp {
  severity = signal<ProductSeverity | undefined>(undefined);
  iconOnly = signal<boolean>(false);
  message = signal<string | undefined>(undefined);

  agInit(params: IProductStatusCellRendererParams): void {
    this.refresh(params);
  }

  // Unlike the device status renderer this never bails out on an absent value: a product the
  // property does not serve arrives as undefined and must still render its dash.
  refresh(params: IProductStatusCellRendererParams): boolean {
    this.severity.set(params.value ?? undefined);
    this.iconOnly.set(params.iconOnly ?? false);
    this.message.set(params.message);

    return true;
  }
}
